// TODO: This is a quick workaround.
//       This action needs to be removed from this project
//       after "toasts" feature is implemented as the standalone package.
import { createAction } from '../../utils'; // TODO: import from `~/lib/redux` instead
export const addToasts = createAction('@@/toasts/ADD_TOASTS');
